<template>
    <v-container class="content-container">
        <h2 
            class="text-center font-weight-medium pt-10 pb-6"
            :class="!isMobilePort ? 'text-h4' : ''"
            :style="isMobilePort ? 'font-size: 24px' : ''">
            Faster compliance with code intelligence tools
        </h2>
        <v-row justify="center" align="stretch" dense>
                <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-for="(tool, index) in tools"
                    :key="index"
                    :class="{ 'pr-5': index !== tools.length - 1 && !isMobilePort }"
                >
                <v-card outlined class="pa-4 rounded-lg">
                    <v-avatar
                        size="56"
                        tile
                        color="primaryLight"
                        class="rounded">
                        <v-img
                            height="40"
                            v-if="tool.type === 'image'"
                            :src="tool.icon" contain>
                        </v-img>
                        <v-icon
                            v-else
                            size="40"
                            color="primary">
                            {{ tool.icon }}
                        </v-icon>
                    </v-avatar>
                    <h6 class="text-h6 font-weight-medium py-4">{{ tool.title }}</h6>
                    <p class="text-body-1 mb-4">{{ tool.description }}</p>
                    <a
                        :href="tool.linkUrl"
                        class="text-body-1 font-weight-medium text-decoration-underline"
                        :class="tool.anchorClass"> <!-- Don't change/remove, using for Google analytics tracking -->
                        {{ tool.linkText }}
                        <v-icon color="primary">mdi-chevron-right</v-icon>
                    </a>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Mobile from '../inc/mixins/mobile';
export default {
    data() {
        return {
            tools: [
                {
                    title: "Instant, AI code help",
                    description: "Get instant code guidance with AI trained by ICC experts.",
                    linkText: "Ask code questions",
                    linkUrl: this.getRoute('features_ai_navigator'),
                    type: 'image',
                    icon: require('../../../app/images/ai_navigator/ai_navigator_icon.svg'),
                    anchorClass: 'tracking_home_link_ask_code_question'
                },
                {
                    title: "Expert code opinions",
                    description: "Professional code assistance in 2 days—personal and fast.",
                    linkText: "Ask ICC experts",
                    linkUrl: this.getRoute('premium_answers'),
                    type: 'image',
                    icon: require('../../../app/images/icons/premium_answers_icon.svg'),
                    anchorClass: 'tracking_home_link_ask_icc_experts'
                },
                {
                    title: "Code calculators",
                    description: "Calculators for occupancy, plumbing, and more.",
                    linkText: "Use calculators",
                    linkUrl: this.getRoute('compliance_calculators'),
                    type: 'icon',
                    icon: 'mdi-calculator-variant-outline',
                    anchorClass: 'tracking_home_link_use_calculators'
                },
                {
                    title: "Revit integration",
                    description: "Validate Revit designs with built-in code access.",
                    linkText: "Get Revit Add-in",
                    linkUrl: this.getRoute('revit'),
                    type: 'icon',
                    icon: 'mdi-domain',
                    anchorClass: 'tracking_home_link_get_revit_addin'
                }
            ]
        }
    },
    mixins: [Mobile],
};
</script>
